import { Component, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { InputComponent } from '../input/input.component';

@Component({
  selector: 'c-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss'],
  standalone: false,
})
export class TextareaComponent extends InputComponent {
  @Input() rows: number | undefined;
  @Input() cols: number | undefined;
  @Input() autoGrow = false;
  @Input() counter = false;

  constructor(@Optional() @Self() public override ngControl: NgControl) {
    super(ngControl);
  }
}
